export default __webpack_public_path__ + "static/media/section1-item-4-h5.4b682d14.png";